exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n*[data-v-4eb93cb7] {\n    position: absolute;\n}\n[data-v-4eb93cb7]:not(.draggable) {\n    /* Prevent our cursor from tricking the user into thinking the element is draggable */\n    cursor: auto !important;\n}\n", ""]);

